//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

export interface solutionsApp {
  name: string;
  path: string;
  routePath: string;
}

export const getRoutePath = (
  solutions: solutionsApp[],
  name: string,
): string | undefined => {
  if (Array.isArray(solutions)) {
    const solution = solutions.find((app) => app.name === name);
    if (solution) {
      return solution.routePath.endsWith('/')
        ? solution.routePath.slice(0, -1)
        : solution.routePath;
    }
  }
  return undefined;
};
